module.exports = __webpack_public_path__ + "r-v3/img/ico_pause_white.9f8a0f7d.svg";